import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import { Box, Card, Chip, Grid, Typography } from '@mui/material';
import { getDashboardVoteInfoFromUserIdApi, getMeetingDashboardInfoFromUserIdApi } from 'api/meeting';
import DashboardPreviousCard from 'app/components/Card/DashboardPreviousCard';
import DashboardReviewCard from 'app/components/Card/DashboardReviewCard';
import DashboardVideoCard from 'app/components/Card/DashboardVideoCard';
import DashboardVoteCard from 'app/components/Card/DashboardVoteCard';
import { dshUyeCardHeight, dshUyeCardScrollHeight } from 'config';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingPopUp from '../LoadingPopup';


function DashboardUyeCard({ type = "uye", onLoaded }) {

    const dispatch = useDispatch();

    const { authUser } = useSelector(state => state.auth);
    const [loading, setLoading] = useState(false);
    const [statReviewList, setStatReviewList] = useState([]);
    const [statVoteList, setStatVoteList] = useState([]);
    const [statVideoList, setStatVideoList] = useState([]);
    const [statFinishList, setStatFinishList] = useState([]);

    useEffect(() => {
        const getAPI = async () => {
            setLoading(true);
            try {
                const needsVote = type !== "superuser";
                const [res, resVote] = await Promise.all([
                    getMeetingDashboardInfoFromUserIdApi(authUser.id, type),
                    needsVote ? getDashboardVoteInfoFromUserIdApi(authUser.id) : Promise.resolve(null),
                ]);

                const meetingsOfTheUser = res?.data?.items || [];

                if (needsVote) {
                    setStatVoteList(resVote?.data?.items || []);
                } else {
                    setStatVoteList(meetingsOfTheUser.filter((item) => item.statVote === 1 && item.statFinish === 0));
                }

                setStatReviewList(meetingsOfTheUser.filter((item) => item.statReview === 1 && item.statFinish === 0));
                setStatVideoList(meetingsOfTheUser.filter((item) => item.statVideoCall === 1 && item.statFinish === 0));
                setStatFinishList(meetingsOfTheUser.filter((item) => item.statFinish === 1));
            } catch (error) {
                console.error('Hata:', error);
            } finally {
                setLoading(false);
            }
        };
        getAPI();

    }, []);

    const fontSize = "10px";

    // background colo: bgColor={'#f5f6fa'}
    return (
        <>

            <LoadingPopUp open={loading} />
            {!loading && (

                <>


                    <Grid container spacing={1}>

                        {/* Değerlendirme Kartı */}
                        <Grid item xs={12} md={3} lg={3}>
                            <Card
                                sx={{
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '8px',
                                    boxShadow: 2,
                                    padding: '8px',
                                    height: dshUyeCardHeight,

                                }}
                            >
                                <JumboScrollbar
                                    autoHeight
                                    autoHeightMin={dshUyeCardScrollHeight}
                                    autoHide
                                    autoHideDuration={200}
                                    autoHideTimeout={500}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', marginLeft: '4px' }}>
                                        <Typography variant="h6" sx={{ color: '#5b5b5b', marginTop: '8px' }}>
                                            Değerlendirme
                                        </Typography>
                                        <Chip
                                            label={statReviewList.length}
                                            size="small"
                                            sx={{
                                                marginLeft: 1,
                                                backgroundColor: '#1976d2',
                                                color: 'white',
                                                fontSize: '0.75rem',
                                                height: '20px',
                                                minWidth: '20px',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                '& .MuiChip-label': {
                                                    padding: '0 4px',
                                                    lineHeight: '20px'
                                                }
                                            }}
                                        />
                                    </Box>

                                    {statReviewList.length > 0 ? (
                                        statReviewList.map((meeting, index) => (
                                            <Box key={index} sx={{ width: '100%', marginBottom: 1 }}>
                                                <DashboardReviewCard meeting={meeting} fontSize={fontSize} />
                                            </Box>
                                        ))
                                    ) : (
                                        <Typography variant="body2" sx={{ color: '#424242' }}>
                                            Toplantı bulunmamaktadır
                                        </Typography>
                                    )}

                                </JumboScrollbar>
                            </Card>
                        </Grid >

                        {/* Oy Verme Kartı */}
                        < Grid item xs={12} md={3} lg={3} >
                            <Card
                                sx={{
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '8px',
                                    boxShadow: 2,
                                    padding: '8px',
                                    height: dshUyeCardHeight,
                                }}
                            >
                                <JumboScrollbar
                                    autoHeight
                                    autoHeightMin={dshUyeCardScrollHeight}
                                    autoHide
                                    autoHideDuration={200}
                                    autoHideTimeout={500}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', marginLeft: '4px' }}>
                                        <Typography variant="h6" sx={{ color: '#5b5b5b', marginTop: '8px' }}>
                                            Oy Verme
                                        </Typography>
                                        <Chip
                                            label={statVoteList.length}
                                            size="small"
                                            sx={{
                                                marginLeft: 1,
                                                backgroundColor: '#5A8F57',
                                                color: 'white',
                                                fontSize: '0.75rem',
                                                height: '20px',
                                                minWidth: '20px',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                '& .MuiChip-label': {
                                                    padding: '0 4px',
                                                    lineHeight: '20px'
                                                }
                                            }}
                                        />
                                    </Box>

                                    {statVoteList.length > 0 ? (
                                        statVoteList.map((meeting, index) => (
                                            <Box key={index} sx={{ width: '100%', marginBottom: 1 }}>
                                                <DashboardVoteCard meeting={meeting} fontSize={fontSize} />
                                            </Box>
                                        ))
                                    ) : (
                                        <Typography variant="body2" sx={{ color: '#424242' }}>
                                            Toplantı bulunmamaktadır
                                        </Typography>
                                    )}

                                </JumboScrollbar>
                            </Card>
                        </Grid >

                        {/* Video Konferans Kartı */}

                        < Grid item xs={12} md={3} lg={3} >
                            <Card
                                sx={{
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '12px',
                                    boxShadow: 3,
                                    padding: '8px',
                                    height: dshUyeCardHeight,
                                }}
                            >
                                <JumboScrollbar
                                    autoHeight
                                    autoHeightMin={dshUyeCardScrollHeight}
                                    autoHide
                                    autoHideDuration={200}
                                    autoHideTimeout={500}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', marginLeft: '4px' }}>
                                        <Typography variant="h6" sx={{ color: '#5b5b5b', marginTop: '8px' }}>
                                            Video Konferans
                                        </Typography>
                                        <Chip
                                            label={statVideoList.length}
                                            size="small"
                                            sx={{
                                                marginLeft: 1,
                                                backgroundColor: '#c2185b',
                                                color: 'white',
                                                fontSize: '0.75rem',
                                                height: '20px',
                                                minWidth: '20px',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                '& .MuiChip-label': {
                                                    padding: '0 4px',
                                                    lineHeight: '20px'
                                                }
                                            }}
                                        />
                                    </Box>

                                    {statVideoList.length > 0 ? (
                                        statVideoList.map((meeting, index) => (
                                            <Box key={index} sx={{ width: '100%', marginBottom: 1 }}>
                                                <DashboardVideoCard meeting={meeting} fontSize={fontSize} />
                                            </Box>
                                        ))
                                    ) : (
                                        <Typography variant="body2" >
                                            Toplantı bulunmamaktadır
                                        </Typography>
                                    )}

                                </JumboScrollbar>
                            </Card>
                        </Grid >

                        <Grid item xs={12} md={3} lg={3}>
                            <Card
                                sx={{
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '12px',
                                    boxShadow: 3,
                                    padding: '8px',
                                    height: dshUyeCardHeight,
                                }}
                            >
                                <JumboScrollbar
                                    autoHeight
                                    autoHeightMin={dshUyeCardScrollHeight}
                                    autoHide
                                    autoHideDuration={200}
                                    autoHideTimeout={500}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px', marginLeft: '4px' }}>
                                        <Typography variant="h6" sx={{ color: '#5b5b5b', marginTop: '8px' }}>
                                            Son Toplantılarınız
                                        </Typography>
                                        <Chip
                                            label={statFinishList.length}
                                            size="small"
                                            sx={{
                                                marginLeft: 1,
                                                backgroundColor: '#F57C00',
                                                color: 'white',
                                                fontSize: '0.75rem',
                                                height: '20px',
                                                minWidth: '20px',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                '& .MuiChip-label': {
                                                    padding: '0 4px',
                                                    lineHeight: '20px'
                                                }
                                            }}
                                        />
                                    </Box>

                                    {statFinishList.length > 0 ? (
                                        statFinishList.map((meeting, index) => (
                                            <Box key={index} sx={{ width: '100%', marginBottom: 1 }}>
                                                <DashboardPreviousCard meeting={meeting} fontSize={fontSize} type="uye" />
                                            </Box>
                                        ))
                                    ) : (
                                        <Typography variant="body2" >
                                            Toplantı bulunmamaktadır
                                        </Typography>
                                    )}

                                </JumboScrollbar>
                            </Card>
                        </Grid>




                    </Grid >




                </>
            )
            }
        </>
    );
};

export default DashboardUyeCard;